import React, { useEffect, useState } from 'react';
import {
  collection,
  getDocs
} from 'firebase/firestore';
import { db } from '../firebase';
import StudentProfile from './StudentProfile';

export default function ViewAllStudents() {
  const [students, setStudents]     = useState([]);
  const [loading, setLoading]       = useState(true);
  const [selected, setSelected]     = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    (async () => {
      const sSnap = await getDocs(collection(db,'students'));
      const raw = sSnap.docs.map(d=>({ id:d.id, ...d.data() }));
      const bSnap = await getDocs(collection(db,'batches'));
      const bMap = {};
      bSnap.docs.forEach(d=> bMap[d.id]=d.data().batch_name);
      setStudents(raw.map(s=>({
        ...s,
        batchNames: (s.batch_ids||[]).map(b=>bMap[b]||b)
      })));
      setLoading(false);
    })();
  }, []);

  if (selected) {
    return <StudentProfile student={selected} onBack={()=>setSelected(null)} />;
  }
  if (loading) return <p>Loading students…</p>;

  const filtered = students.filter(s =>
    s.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">All Students</h2>
      <input
        type="text"
        placeholder="Search..."
        value={searchTerm}
        onChange={e=>setSearchTerm(e.target.value)}
        className="mb-4 px-3 py-2 border rounded w-full max-w-sm"
      />
      {filtered.length===0 ? (
        <p>No students found.</p>
      ) : (
        <ul className="space-y-2">
          {filtered.map(s=>(
            <li key={s.id} className="p-3 bg-white rounded shadow flex justify-between">
              <div>
                <div className="font-medium">{s.name} — Class {s.class}</div>
                <div className="text-sm text-gray-600">Batch: {s.batchNames.join(', ')||'None'}</div>
              </div>
              <button
                onClick={()=>setSelected(s)}
                className="px-3 py-1 bg-blue-600 text-white rounded"
              >
                View Profile
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
